/**
 * Tenant portal session token (from POST /api/tenant-invitations/login or /activate).
 * Kept in localStorage: the production API is on another site, so a cookie would not be sent.
 */

const STORAGE_KEY = 'zrfTenantSession';
const LEGACY_AUTO_LOGIN_KEY = 'tenantAutoLogin';
export const TENANT_SESSION_HEADER = 'X-Tenant-Session';
export const TENANT_SESSION_ENDED_EVENT = 'zrf:tenant-session-ended';

export function getTenantSession() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (!session?.token || (session.expiresAt && new Date(session.expiresAt).getTime() <= Date.now())) {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return session;
  } catch (_) {
    return null;
  }
}

/** @param {{ sessionToken: string, expiresAt?: string }} loginResponse */
export function saveTenantSession(loginResponse) {
  if (!loginResponse?.sessionToken) return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
    token: loginResponse.sessionToken,
    expiresAt: loginResponse.expiresAt || null
  }));
  window.localStorage.removeItem(LEGACY_AUTO_LOGIN_KEY);
}

export function clearTenantSession({ notify = false } = {}) {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
    window.localStorage.removeItem(LEGACY_AUTO_LOGIN_KEY);
  } catch (_) {
    /* storage unavailable */
  }
  if (notify && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new Event(TENANT_SESSION_ENDED_EVENT));
  }
}

/** API calls that are authorized with the tenant session rather than a landlord login. */
export function isTenantSessionUrl(url = '') {
  return url.includes('/api/tenant-portal/') || url.includes('/api/tenant-invitations/change-password');
}

export function isTenantPortalPage(pathname = window.location.pathname) {
  return pathname === '/tenant-portal' || pathname.startsWith('/tenant-portal/');
}

/** Tenant name for display from a session/login summary. */
export function tenantDisplayName(summary = {}) {
  return `${summary.firstName || ''} ${summary.lastName || ''}`.trim() || summary.email || 'Tenant';
}
